//@ts-nocheck
/* 
 *  This file super-user.resolver.service.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2022  
 *  (C) 2015-2022. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *  
 */

import { Injectable } from "@angular/core";

import { SharedService } from "./shared.service";
import { AuthService } from "./auth-service";

@Injectable()
export class SuperUserResolverService {
    constructor(
        private authService: AuthService,
        public sharedService: SharedService) { }

    async resolve() {
        const superUserLogOnDetails = JSON.parse(localStorage.getItem('superUserLogOnDetails'));
        const superUserAccessRights = JSON.parse(localStorage.getItem('superUserAccessRights'));

        if (superUserLogOnDetails && superUserAccessRights) {
            this.sharedService.superUserLogOnDetails = superUserLogOnDetails;
            this.sharedService.superUserMenuList = superUserAccessRights;
        } else {
            this.authService.logout();
            return;
        }
    }
}